import { icons, LucideIcons } from 'lucide-angular';

/**
 * Tự động đăng ký icon cho Modal qua Registry giống cơ chế của menu-icons.ts.
 * Bất kỳ màn hình nào gọi this.modalService.open(..., { icon: '...' }) đều sẽ
 * tự động nhận diện được icon (hỗ trợ cả kebab-case như 'user-plus' và PascalCase như 'UserPlus')
 * mà không cần phải import thủ công từng icon vào module.
 */
export const modalLucideIcons: LucideIcons = icons as LucideIcons;
